import { useState, useEffect} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth } from '../../components/button'
import { TextInput } from '../../components/input'
import GoBack from '../../components/back/GoBack'
import SettingsMenu from '../staticscreens/SettingsMenu'
import { CreateSubscriptionService, UpdateSubscriptionService } from '../../services/admin/SubscriptionServices'
import { CreateWorkFromHomeEmployeeOptionService, GetWorkFromHomeEmployeeOptionService, UpdateWorkFromHomeEmployeeOptionService } from '../../services/admin/WFHOptionServices'

function WorkFromHomeEmployeeOption() {
 
  const [data,setdata] = useState({assign_count:'',amount:''});  
  const [error,seterror] = useState({assign_count:'',amount:''}); 
  
   useEffect(()=>{
      getdata()
    },[])
  
    async function getdata() {
      const response = await GetWorkFromHomeEmployeeOptionService()
      if(response?.data?.datas?.length > 0){
          setdata(response?.data?.datas[0])
      }
    }

  function handlechange(e){
    setdata({...data,[e.target.name] : parseInt(e.target.value)})
    seterror({...error,[e.target.name]:''})
  }
  

  async function resetform(){
    setdata({assign_count:'',amount:''})
    seterror({assign_count:'',amount:''})
  }

  async function submitdata() {
     if(!data.assign_count){
        seterror({...error,assign_count:'Assign Count field is required to make changes*'})
    }else if(!data.amount){
        seterror({...error,amount:'Amount field is required to make changes*'})
    }else{
    if(data?._id === undefined || data?._id === null){
        const response = await CreateWorkFromHomeEmployeeOptionService(data)
        if (response.status === 201) {
          resetform()
          getdata()
          toast.success('WFH Employee Option Created Successfully')
        } 
    }else{
       const response = await UpdateWorkFromHomeEmployeeOptionService(data,data?._id)
        if (response.status === 200) {
          resetform()
          getdata()
          toast.success('WFH Employee Option Update Successfully')
        } 
    }
    }
  }

  function openFile(v){
    let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${v}`
    window.open(url,'_blank')
  }


  

  

  return (
    <div className='md:flex '>


    <SettingsMenu />
 
  <div className='sm:w-full lg:w-72 px-4 pt-5' >


      <GoBack /> 
      
      

        <h6 className='font-bold'>Work From Home Employee Option</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create / update <b>Work From Home Employee Option</b>.</h6>
     

        <TextInput 
            mandatory={true}
            label={'Assign Count'}  
            variant="standard"
            name="assign_count"
            type="number"
            error={error.assign_count}
            value={data.assign_count}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

         <TextInput 
            mandatory={true}
            label={'Amount'}  
            variant="standard"
            name="amount"
            type="number"
            error={error.amount}
            value={data.amount}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>    

          
          <div className='my-5'>
           <ButtonFilledAutoWidth btnName="Save"  onClick={submitdata} />  
          </div>



    </div>
    </div>
  )
}

export default WorkFromHomeEmployeeOption